/** 미국(해외) 주식 거래 수수료 */
export const US_STOCK_TRADE_FEE = 0.1;
